import {
  WithStyles,
  withStyles,
  Tabs,
  Tab,
  Paper,
  Grid,
  Typography,
} from "@material-ui/core";
import React, { Component } from "react";
import { connect } from "react-redux";
import { userStyles } from "../styles";
import TabPanel from "../common/TabPanel";
import ClientListing from "../components/ClientListing";
import RoleListing from "../components/RoleListing";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { addPropToToastClose, addUserToastClose, switchSelectedTab, searchUserMgmt } from "../actions/userActions";
import CloseIcon from "@material-ui/icons/Close";
import UserListing from "../components/UserListing";
import TopHeader from "./TopHeader";
import { toggleLicenseExpiredDialog, setLoggedInUser } from "../../login/actions/userActions";
import FilterDialog from "../common/FilterDialog";
import { MyPATSearchBar } from "../../common";
interface NavHeaderProps extends WithStyles<typeof userStyles> {
  userDetails: any;
  onTabChange: (value: any) => void;
  addPropToToastClose: any;
  addUserToastClose: any;
  roleAddedSuccessfully: boolean;
  userAddedSuccessfully: boolean;
  selectedTab: any;
  changeTab: boolean;
  switchSelectedTab: any;
  isSetRoles: any;
  isSetUsers: any;
  isSetClients: any;
  isPostExpiryDays: any;
  toggleLicenseExpiredDialog: any;
  setLoggedInUser: any;
  searchClients: Function;
  searchRoles: Function;
  searchUsers: Function;
  searchUserMgmt: Function;
  usersSearchData: any;
}
interface NavHeaderState {
  value: number;
  userDetails: any;
  isAdmin: any;
  isSuperAdmin: any;
  selectedTab: any;
  isSetRoles: any;
  isSetUsers: any;
  isSetClients: any;
}

interface RolesSearchObject {
	clients: string[],
	roles: string[]
}

interface UsersSearchObject {
	status: boolean,
	userDetails: string[],
	clients: string[],
	roles: string[]
}

interface SearchDataObject {
  searchText?: string,
  rolesSearch?: RolesSearchObject,
  usersSearch?: UsersSearchObject
}



class NavHeader extends Component<NavHeaderProps, NavHeaderState> {
  constructor(props: NavHeaderProps) {
    super(props);
    this.state = {
      value: 0,
      userDetails: {},
      isAdmin: false,
      isSuperAdmin: false,
      selectedTab: "Users",
      isSetRoles: false,
      isSetUsers: false,
      isSetClients: false
    };
    this.handleTabChange = this.handleTabChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
  }
  a11yProps(index: any) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }
  handleTabChange(event: any, newValue: any) {
    this.setState({ value: newValue },
      () => {
        this.setSelectedTab();
      }
      );
    this.props.onTabChange(newValue);
  }

  handleSearch = (searchText: string) => {
    switch(this.state.selectedTab){
      case 'Clients': this.props.searchClients(searchText); break;
      case 'Users': this.props.searchUsers(searchText); break;
      case 'Roles': this.props.searchRoles(searchText); break;
      default:
    }
  }

  handleToaster = () => {
    this.props.addPropToToastClose();
    this.props.addUserToastClose();
  };
  componentDidMount(){
    this.props.setLoggedInUser();
    setTimeout( ()=> {
      this.props.addPropToToastClose();
      this.props.addUserToastClose();
    }, 4000)
  }
  componentDidUpdate(prevProps: any, prevState: any) {

    if(prevProps.userDetails !== this.props.userDetails) {
      this.setState({
        userDetails: this.props.userDetails,
        isAdmin:
        this.props.userDetails &&
        this.props.userDetails.authenticatedUser &&
        this.props.userDetails.authenticatedUser.isAdmin,
      isSuperAdmin:
        this.props.userDetails &&
        this.props.userDetails.authenticatedUser &&
        this.props.userDetails.authenticatedUser.isSuperAdmin},
        )  
    }
    if (prevState.isSuperAdmin !== this.state.isSuperAdmin) {
     this.setSelectedTab();
    }
    if (prevState.isAdmin !== this.state.isAdmin) {
      this.setSelectedTab();
     }
    if(prevProps.roleAddedSuccessfully !== this.props.roleAddedSuccessfully) {
      this.props.switchSelectedTab("Roles");
    }
    if(prevProps.userAddedSuccessfully !== this.props.userAddedSuccessfully) {
      this.props.switchSelectedTab("Users");
    }
    if((prevProps.selectedTab !== this.props.selectedTab)) {
      this.setState({
        selectedTab: this.props.selectedTab
      })
      this.changeSelectedTab();
    }
    if(prevState.isSetRoles !== this.props.isSetRoles) {
      this.setState({
        selectedTab: "Roles",
        isSetRoles: this.props.isSetRoles
      },
     () => {
      this.changeSelectedTab();
     } 
      )
    }
    if(prevState.isSetUsers !== this.props.isSetUsers) {
      this.setState({
        selectedTab: "Users",
        isSetUsers: this.props.isSetUsers
      },
     () => {
      this.changeSelectedTab();
     } 
      )
    }
    if(prevState.isSetClients !== this.props.isSetClients) {
      this.setState({
        selectedTab: "Clients",
        isSetClients: this.props.isSetClients
      },
     () => {
      this.changeSelectedTab();
     } 
      )
    }
  }
  setSelectedTab() {
    if (this.state.isSuperAdmin) {
      switch (this.state.value) {
        case 0:  this.setState({selectedTab: "Clients"});
        break;
        case 1:  this.setState({selectedTab: "Roles"});
        break;
        case 2:  this.setState({selectedTab: "Users"});
        break;
      }
    } else if (this.state.isAdmin) {
      switch (this.state.value) {
        case 0: this.setState({selectedTab: "Roles"});
        break;
        case 1: this.setState({selectedTab: "Users"});
        break;
      }
    } else {
      switch (this.state.value) {
        case 0: this.setState({selectedTab: "Users"});
        break;
      }
    }
  }
  changeSelectedTab() {
    let value = this.props.selectedTab !== "" ? this.props.selectedTab : this.state.selectedTab;
    if (this.state.isSuperAdmin) {
      switch (value) {
        case "Clients":
          return this.setState({ value: 0 });
        case "Roles":
          return this.setState({ value: 1 });
        case "Users":
          return this.setState({ value: 2 });
      }
    } else if (this.state.isAdmin) {
      switch (value) {
        case "Roles":
          return this.setState({ value: 0 });
        case "Users":
          return this.setState({ value: 1 });
      }
    } else {
      switch (value) {
        case "Users":
          return this.setState({ value: 0 });
      }
    }
  }

  renderHeader() {
    const { classes, isPostExpiryDays } = this.props;
    const { value, userDetails, isSuperAdmin, isAdmin } = this.state;
    return (
      <>
        {this.props.roleAddedSuccessfully && (
          <Grid
            className={[classes.customToaster, classes.successTooltip].join(
              " "
            )}
          >
            <Typography variant="h6">
              <span>
                <CheckCircleIcon />
              </span>
              <span>Role Added Successfully</span>
              <span className="closeIcon" onClick={this.handleToaster}>
                <CloseIcon />
              </span>
            </Typography>
          </Grid>
        )}
        {/* {this.props.userAddedSuccessfully && (
          <Grid
            className={[classes.customToaster, classes.successTooltip].join(
              " "
            )}
          >
            <Typography variant="h6">
              <span>
                <CheckCircleIcon />
              </span>
              <span>User Added Successfully</span>
              <span className="closeIcon" onClick={this.handleToaster}>
                <CloseIcon />
              </span>
            </Typography>
          </Grid>
        )} */}
        <div className={classes.navbarRoot}>
          {isSuperAdmin && (
            <>
              <Paper
                square
                classes={{
                  root: [classes.navPaperRoot, classes.marginTop32].join(" "),
                }}
              >
                <Grid container justify="space-between" alignItems="center">
                <Grid item>
                  <Tabs
                  value={value}
                  onChange={this.handleTabChange}
                  indicatorColor="primary"
                  textColor="primary"
                  classes={{
                    indicator: classes.navTabsIndicator,
                  }}
                  aria-label="simple tabs example"
                >
                  <Tab
                    classes={{
                      root: [
                        classes.paddingBottomZero,
                        classes.labelHeading,
                      ].join(" "),
                    }}
                    label="Clients"
                    {...this.a11yProps(0)}
                  />
                  <Tab
                    classes={{
                      root: [
                        classes.paddingBottomZero,
                        classes.labelHeading,
                      ].join(" "),
                    }}
                    label="Roles"
                    {...this.a11yProps(1)}
                  />
                  <Tab
                    classes={{
                      root: [
                        classes.paddingBottomZero,
                        classes.labelHeading,
                      ].join(" "),
                    }}
                    label="Users"
                    {...this.a11yProps(2)}
                  />
                </Tabs>
                </Grid>
                {this.state.selectedTab !== 'Roles' && <Grid item>
                  <Grid container justify="space-between" spacing={24} alignItems="center">
                    <Grid item>
                      <span className="searchBar">
                        <MyPATSearchBar 
                        isSelect={this.state.selectedTab === 'Clients' ? false : true }
                        // searchText={this.state.searchText}
                        isRolesTab={this.state.selectedTab === 'Roles' ? true : false}
                        isUsersTab={this.state.selectedTab === 'Users' ? true : false}
                        searchTextChanged={(searchData: SearchDataObject) => this.searchBarText(searchData)}
                        showCancelIcon={true}
                        />
                        </span>
                    </Grid>
                  </Grid>
                </Grid>}
                </Grid>
              </Paper>
              <TabPanel value={value} index={0}>
                <ClientListing />
              </TabPanel>
              <TabPanel value={value} index={1}>
                <RoleListing userDetails={userDetails} isPostExpiryDays={this.props.isPostExpiryDays} isSuperAdmin={this.state.isSuperAdmin}/>
              </TabPanel>
              <TabPanel value={value} index={2}>
                <UserListing isPostExpiryDays={this.props.isPostExpiryDays} />
              </TabPanel>
            </>
          )}
          {isAdmin && (
            <>
              <Paper
                square
                classes={{
                  root: [classes.navPaperRoot, classes.marginTop32].join(" "),
                }}
              >
                <Grid container justify="space-between" alignItems="center">
                <Grid item>
                <Tabs
                  value={value}
                  onChange={this.handleTabChange}
                  indicatorColor="primary"
                  textColor="primary"
                  classes={{
                    indicator: classes.navTabsIndicator,
                  }}
                  aria-label="simple tabs example"
                >
                  <Tab
                    classes={{
                      root: [
                        classes.paddingBottomZero,
                        classes.labelHeading,
                      ].join(" "),
                    }}
                    label="Roles"
                    {...this.a11yProps(0)}
                  />
                  <Tab
                    classes={{
                      root: [
                        classes.paddingBottomZero,
                        classes.labelHeading,
                      ].join(" "),
                    }}
                    label="Users"
                    {...this.a11yProps(1)}
                  />
                </Tabs>
              </Grid>
                {this.state.selectedTab !== 'Roles' && <Grid item>
                  <Grid container justify="space-between" alignItems="center" spacing={16}>
                    <Grid item>
                      <span className={classes.searchBox}>
                        <MyPATSearchBar 
                        isSelect={this.state.selectedTab === 'Clients' ? false : true } 
                        // searchText={this.state.searchText}
                        isRolesTab={this.state.selectedTab === 'Roles' ? true : false}
                        isUsersTab={this.state.selectedTab === 'Users' ? true : false}
                        searchTextChanged={(searchData: SearchDataObject) => this.searchBarText(searchData)}
                        showCancelIcon={true}
                        />
                        </span>
                    </Grid>
                   
                  </Grid>
                </Grid>}
              </Grid>
              </Paper>
              <TabPanel value={value} index={0}>
                <RoleListing userDetails={userDetails} isSuperAdmin={this.state.isSuperAdmin} />
              </TabPanel>
              <TabPanel value={value} index={1}>
                <UserListing />
              </TabPanel>
            </>
          )}
          {!isAdmin && !isSuperAdmin && (
            <>
              <Paper
                square
                classes={{
                  root: [classes.navPaperRoot, classes.marginTop32].join(" "),
                }}
              >
                <Grid container justify="space-between" alignItems="center">
                  <Grid item>
                <Tabs
                  value={value}
                  onChange={this.handleTabChange}
                  indicatorColor="primary"
                  textColor="primary"
                  classes={{
                    root: classes.marginTopSM,
                    indicator: classes.navTabsIndicator,
                  }}
                  aria-label="simple tabs example"
                >
                  <Tab
                    classes={{
                      root: [
                        classes.paddingBottomZero,
                        classes.labelHeading,
                      ].join(" "),
                    }}
                    label="Users"
                    {...this.a11yProps(1)}
                  />
                </Tabs>
                    </Grid>
                   {this.state.selectedTab !== 'Roles' && <Grid item>
                  <Grid container justify="space-between" alignItems="center" spacing={16}>
                    <Grid item>
                      <span className={classes.searchBox}>
                        <MyPATSearchBar 
                        isSelect={this.state.selectedTab === 'Clients' ? false : true } 
                        isRolesTab={this.state.selectedTab === 'Roles' ? true : false}
                        isUsersTab={this.state.selectedTab === 'Users' ? true : false}
                        // searchText={this.state.searchText}
                        searchTextChanged={(searchData: SearchDataObject) => this.searchBarText(searchData)}
                        showCancelIcon={true}
                        />
                        </span>
                    </Grid>
                  </Grid>
                </Grid>}
                </Grid>
              </Paper>
              <TabPanel value={value} index={0}>
                <UserListing />
              </TabPanel>
            </>
          )}
        </div>
      </>
    );
  }

  searchBarText(searchData: SearchDataObject){
    const { searchText, rolesSearch, usersSearch } = searchData;
    console.log('Search Text',searchText)
    console.log('Roles Search',rolesSearch)
    console.log('Users Search',usersSearch)
    this.props.searchUserMgmt({
      selectedTab: this.state.selectedTab,
      isSuperAdmin: this.state.isSuperAdmin,
      searchText: searchText,
      rolesSearch: rolesSearch,
      usersSearch: this.props.usersSearchData,
    })
  }

  render() {
    
    return (
      <div>
        <TopHeader selectedTab={this.state.selectedTab} isPostExpiryDaysProp={this.props.isPostExpiryDays}/>
        <FilterDialog />
        {this.renderHeader()}
      </div>
    );
  }
}
const mapStateToProps = (state: any) => ({
  roleAddedSuccessfully:
    state.clientManagement.rolesManagement.roleAddedSuccessfully,
  userAddedSuccessfully:
    state.clientManagement.usersManagement.userAddedSuccessfully,
  selectedTab: state.clientManagement.usersManagement.selectedTab,
  isSetRoles: state.clientManagement.usersManagement.isSetRoles,
  isSetUsers: state.clientManagement.usersManagement.isSetUsers,
  isSetClients: state.clientManagement.usersManagement.isSetClients,
  isPostExpiryDays: state.loginData.userData && state.loginData.userData.isPostExpiryDays,
  usersSearchData: state.clientManagement.usersManagement.usersSearchData
});

const mapDispatchToProps = {
  addPropToToastClose,
  addUserToastClose,
  switchSelectedTab,
  setLoggedInUser,
  toggleLicenseExpiredDialog,
  searchUserMgmt
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(userStyles)(NavHeader));
